import { render, staticRenderFns } from "./VariableTextOutputField.vue?vue&type=template&id=5a84f792&scoped=true&"
import script from "./VariableTextOutputField.vue?vue&type=script&lang=ts&"
export * from "./VariableTextOutputField.vue?vue&type=script&lang=ts&"
import style0 from "./VariableTextOutputField.vue?vue&type=style&index=0&id=5a84f792&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a84f792",
  null
  
)

export default component.exports